import React from "react";

export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error?: any }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, info: any) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
          <div className="max-w-lg w-full bg-white border border-slate-200 rounded-2xl p-6 shadow">
            <h1 className="text-xl font-black text-slate-900">Oups — petite erreur</h1>
            <p className="text-sm text-slate-600 mt-2">
              La page a rencontré un bug, mais le site reste fonctionnel.
            </p>
            <pre className="text-xs bg-slate-100 mt-4 p-3 rounded-xl overflow-auto text-slate-700">
              {String(this.state.error)}
            </pre>
            <button
              className="mt-4 px-4 py-2 rounded-xl bg-slate-900 text-white font-bold text-sm"
              onClick={() => window.location.reload()}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
